import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
} from "@mui/material";
import { Select } from "@mui/material";
import CustomInput from "../../../shared/utils/Input";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Styles from "../../../styles/vendorDashboard.module.css";
import SaveIcon from "@mui/icons-material/Save";
import { InputLabel } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Cross } from "../../../shared/assets/icons";
import { VerifiedTick } from "../../../shared/assets/icons";
import { statecityData } from "../../../shared/enums";
import { useSelector } from "react-redux";

const OrganisationForm = ({
  handleSave,
  handleChange,
  formData,
  errors,
  hasChanges,
  cityArray,
  loading,
  isGstVerified,
}) => {
  return (
    <Box p={2}>
      <Card variant="outlined" sx={{ borderRadius: 5 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Organisational Details
            </Typography>
            {hasChanges && (
              <Button
                onClick={handleSave}
                startIcon={<SaveIcon />}
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            )}
          </Box>

          <Box sx={{ overflowY: "scroll", maxHeight: "48vh" }}>
            <Grid container spacing={3}>
              {/* GSTIN */}
              <Grid item xs={12} md={6}>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: errors.GSTIN ? "#d32f2f" : "inherit",
                    }}
                    gutterBottom
                  >
                    GSTIN *
                  </Typography>
                  <TextField
                    fullWidth
                    name="GSTIN"
                    value={formData.GSTIN || ""}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    error={!!errors.GSTIN}
                    helperText={errors.GSTIN}
                  />
                  {loading ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "70%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress color="inherit" size={20} />
                    </div>
                  ) : errors.GSTIN ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "53%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Cross
                        color="var(--error-color)"
                        fillcolor="var(--error-color)"
                      />
                    </div>
                  ) : isGstVerified ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "70%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <VerifiedTick
                        color="var(--third-color)"
                        fillcolor="var(--third-color)"
                      />
                    </div>
                  ) : null}
                </div>
              </Grid>
              {/* <Grid item xs={12} md={6}>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "100%",
                  }}
                >
                  <CustomInput
                    placeholder="Enter GSTIN"
                    size="small"
                    title="GSTIN *"
                    name="GSTIN"
                    value={formData.GSTIN}
                    onChange={handleChange}
                    error={!!errors.GSTIN}
                    errorMessage={errors.GSTIN}
                  />
                  {loading ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "70%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress color="inherit" size={20} />
                    </div>
                  ) : errors.GSTIN ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "53%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Cross
                        color="var(--error-color)"
                        fillcolor="var(--error-color)"
                      />
                    </div>
                  ) : isGstVerified ? (
                    <div
                      style={{
                        position: "absolute",
                        top: "70%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        width: "20px",
                        height: "20px",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <VerifiedTick
                        color="var(--third-color)"
                        fillcolor="var(--third-color)"
                      />
                    </div>
                  ) : null}
                </div>
              </Grid> */}

              {/* Organization Name */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.vendorBusinessName ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Organization Name *
                </Typography>
                <TextField
                  fullWidth
                  name="vendorBusinessName"
                  value={formData.vendorBusinessName || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors.vendorBusinessName}
                  helperText={errors.vendorBusinessName}
                />
              </Grid>

              {/* Address */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.address ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Address *
                </Typography>
                <TextField
                  fullWidth
                  name="address"
                  value={formData.address || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors.address}
                  helperText={errors.address}
                />
              </Grid>

              {/* Landmark */}
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Landmark
                </Typography>
                <TextField
                  fullWidth
                  name="landmark"
                  value={formData.landmark || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors.landmark}
                  helperText={errors.landmark}
                />
              </Grid>

              {/* State */}

              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  fontWeight={600}
                  className={`${Styles.labelColor} ${
                    errors?.state
                      ? "text-[var(--error-color)]"
                      : "text-[var(--heading-color)]"
                  }`}
                  gutterBottom
                >
                  State *
                </Typography>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem" }}
                  error={errors.state}
                  errorMessage={
                    errors.state ? (
                      <span style={{ color: "var(--error-color)" }}>
                        Please Enter State
                      </span>
                    ) : null
                  }
                  value={formData?.state.name || formData?.state}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Set border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on focus
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on hover
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: "#b0b0b0", // Ensure hover state is consistent
                        },
                      },
                    }}
                    style={{ color: formData?.state ? "" : "#a2a2a2" }}
                    displayEmpty
                    name="state"
                    value={formData?.state}
                    onChange={handleChange}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            State
                          </p>
                        );
                      }

                      return selected;
                    }}
                  >
                    {statecityData.map((state) => (
                      <MenuItem key={state.name} value={state.name}>
                        {state.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.state && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                    {errors.state}
                  </p>
                )}
              </Grid>

              {/* City */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  fontWeight={600}
                  className={`${Styles.labelColor} ${
                    errors?.city
                      ? "text-[var(--error-color)]"
                      : "text-[var(--heading-color)]"
                  }`}
                  gutterBottom
                >
                  City *
                </Typography>

                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem" }}
                  error={errors.city}
                  errorMessage={
                    errors.city ? (
                      <span style={{ color: "var(--error-color)" }}>
                        Please Enter City
                      </span>
                    ) : null
                  }
                  value={formData?.city}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Set border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on focus
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on hover
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: "#b0b0b0", // Ensure hover state is consistent
                        },
                      },
                    }}
                    style={{ color: formData?.city ? "" : "#a2a2a2" }}
                    displayEmpty
                    name="city"
                    value={formData?.city}
                    onChange={handleChange}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            City
                          </p>
                        );
                      }

                      return selected;
                    }}
                  >
                    {cityArray.map((city) => (
                      <MenuItem key={city.id} value={city.name}>
                        {city.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {errors.state && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                    {errors.city}
                  </p>
                )}
              </Grid>

              {/* Pincode */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.pinCode ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Pincode *
                </Typography>

                <TextField
                  fullWidth
                  name="pinCode"
                  value={formData?.pinCode || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors?.pinCode}
                  helperText={errors?.pinCode}
                />
              </Grid>

              {/* Established Year */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.yearsInBusiness ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Established Year *
                </Typography>
                <TextField
                  fullWidth
                  name="yearsInBusiness"
                  value={formData.yearsInBusiness || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors.yearsInBusiness}
                  helperText={errors.yearsInBusiness}
                />
              </Grid>

              {/* Website */}
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Website URL
                </Typography>
                <TextField
                  fullWidth
                  name="website"
                  value={formData.website || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors.website}
                  helperText={errors.website}
                />
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OrganisationForm;
